import React from 'react';

class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      test: 'test'
    };
  }
  render() {
    return (
      <div>
        This is about! 
      </div>
    );
  }
}

export default About;



/** WEBPACK FOOTER **
 ** ./src/app/components/About/About.js
 **/